import { Box } from "@/Components/v2/atoms/Box";
import { colors } from "@/Components/v2/utils/brand-colors";
import { InvestmentRating, InvestmentRatingMap } from "@/pages/investment-levels/constants/maps";

const ChannelStatus = ({ status }: { status: InvestmentRating }) => {
  if (!status) return <></>;
  const { label, labelColor } = InvestmentRatingMap[status];
  return (
    <Box
      sx={{
        backgroundColor: labelColor,
        color: colors.black,
        padding: "4px 8px",
        borderRadius: 1,
      }}
    >
      {label}
    </Box>
  );
};

export default ChannelStatus;
